export default __webpack_public_path__ + "static/02-86265fcdc68642161003211abfef7d75.jpg";